// extracted by mini-css-extract-plugin
export default {"main":"_0b7b9ebd41","tit":"_01cb900b83","maintitle":"a3d816583d","ylw":"f2a5e2c66c","white":"_6b2f04b6cd","mv_title":"b7d27e691b","mv_nc":"_0fa51c7c67","mv_in":"b584d098c7"};